import React from 'react';
import styles from './BenefactorConsentedDocuments.module.scss';
import {useBenefactorConsents} from '../../../consents';
import {BenefactorConsentedDocumentsTable} from '../BenefactorConsentedDocumentsTable';
import {Loader} from '@gravity-ui/uikit';

interface BenefactorConsentedDocumentsProps {
  benefactorId?: string;
}

export const BenefactorConsentedDocuments = ({benefactorId}: BenefactorConsentedDocumentsProps) => {
  const {data, isLoading} = useBenefactorConsents(benefactorId);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Loader size="l" />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <BenefactorConsentedDocumentsTable documents={data?.documents || []} isLoading={isLoading} />
    </div>
  );
};
